import React from 'react';
import MovieTile from '../components/movie-tile';
import {StatusBar} from 'expo-status-bar';
import {ScrollView, StyleSheet, Text, TextInput} from 'react-native';
import {searchMovies} from '../services/movie-service';

class HomeScreen extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      movieTiles: []
    }
  }

  render() {
    return (
        <ScrollView contentContainerStyle={styles.container}>
          <Text style={styles.heading}>Movie Tracker</Text>
          <TextInput
              placeholder="Search for a movie"
              style={styles.search}
              onSubmitEditing={this.onSearchTextSubmit.bind(this)}
          />
          {this.state.movieTiles}
          <StatusBar style="auto"/>
        </ScrollView>
    );
  }

  onSearchTextSubmit(event) {
    searchMovies(event.nativeEvent.text).then((movies) => {
      let newMovieTiles = movies.map((movie) => {
        return (
            <MovieTile
                movie={movie}
                key={movie.id}
            />
        );
      })
      this.setState({movieTiles: newMovieTiles});
    });
  }
}

const styles = StyleSheet.create({
  container: {
    backgroundColor: '#fff',
    alignItems: 'center',
    justifyContent: 'top',
  },
  heading: {
    fontSize: 30,
    fontWeight: 'bold',
    margin: 20
  },
  search: {
    borderColor: 'gray',
    borderWidth: 1,
    padding: 10,
    width: '80%'
  },
});

export default HomeScreen;
